var generateCode = function generateCode(length, prefix, suffix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var result = '';
  for (var i = length; i > 0; i -= 1) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return [prefix, result, suffix].filter(function (notEmpty) {
    return notEmpty;
  }).join('');
};
export default generateCode;